import { useEffect, useState } from "react";
import { userDetailState, userSettingState } from "store/selectors";
import {
  Button,
  Checkbox,
  CustomModal,
  Headings,
  LoadingSpinner,
  Modal,
} from "components/ui";
import { ConditionalRenderer } from "components";
import { aggregateUserSettings } from "./helpers";
import { userSettingsActionTypes } from "utils/constants";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { fetchUserSettings, updateUserSettings } from "store/actions";
import { themeObject } from "./constants";
import styles from "./styles.module.css";

const { updateUserSettingsFulfilled } = userSettingsActionTypes;
const { dark, light } = themeObject;

export function ViewSettingsPopover({ showModal, onClose }: any) {
  const { userDetail } = useAppSelector(userDetailState);
  const { loading, settings, isDarkMode } = useAppSelector(userSettingState);
  const [userSettings, setUserSettings] = useState<any>({});
  const dispatch = useAppDispatch();

  useEffect(() => {
    setUserSettings(settings[0]);
  }, [settings]);

  function settingsHandler(key: any) {
    return (value: any) => {
      if (key === light) {
        return setUserSettings({
          ...userSettings,
          [key]: value,
          [dark]: !value,
        });
      }

      if (key === dark) {
        return setUserSettings({
          ...userSettings,
          [key]: value,
          [light]: !value,
        });
      }

      setUserSettings({
        ...userSettings,
        [key]: value,
      });
    };
  }

  async function submitHandler() {
    const action = await dispatch(
      updateUserSettings({
        updatedSettings: userSettings,
        settingId: userSettings?.id,
      })
    );

    if (action.type === updateUserSettingsFulfilled) {
      dispatch(fetchUserSettings({ userId: userDetail?.id }));
    } else {
      setUserSettings(settings[0]);
    }
  }

  const modifiedUserSettings = aggregateUserSettings(userSettings);

  return (
    <CustomModal
      isOpen={showModal}
      onClose={onClose}
      classes={styles.modalWidth}
    >
      <ConditionalRenderer condition={loading}>
        <LoadingSpinner />
      </ConditionalRenderer>
      <Modal.Header title="Settings" />
      <Modal.Body>
        <div className={styles.popoverContainer}>
          {Object.entries(modifiedUserSettings).map((state: any) => {
            const [title, settingsArr] = state || {};
            return (
              <>
                <Headings.LevelFour
                  classes={`${styles.heading} ${
                    isDarkMode ? styles.darkHeading : ""
                  }`}
                >
                  {title}
                </Headings.LevelFour>
                <div className={styles.gridContainer}>
                  {settingsArr.map((item: any) => {
                    return (
                      <label
                        id={item.key}
                        key={item.key}
                        className={`${styles.label} ${
                          isDarkMode ? styles.darkLabel : ""
                        }`}
                      >
                        <Checkbox
                          name={item.key}
                          classes="w-4 h-4"
                          onChange={settingsHandler(item.key)}
                          checked={item?.value}
                        />
                        {item?.key?.split("_").join(" ") || ""}
                      </label>
                    );
                  })}
                </div>
              </>
            );
          })}
        </div>
      </Modal.Body>

      <Modal.Footer classes="flex justify-center">
        <Button
          variant="green"
          type="button"
          className="w-full max-w-96 !py-3"
          onClick={submitHandler}
        >
          Update
        </Button>
      </Modal.Footer>
    </CustomModal>
  );
}
